import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['destroyAttachmentLink']

  connect() {
    // alert('fuck you')
  }

  displayDeleteProgress(event) {
    event.currentTarget.value = '...deleting';
    event.currentTarget.readOnly = true;
    event.currentTarget.classList.add('text-muted')
  }

  // create(event) {
  //   var csrf = document.getElementsByName('csrf-token')[0].content;
  //   var record_model = event.currentTarget.dataset.recordModel;

  //   // var record_id = event.currentTarget.dataset.recordId;
  //   // console.log(`record_id: ${record_id}`)
  //   var path = event.currentTarget.dataset.createPath;
  //   // console.log(`path: ${path}`)

  //   if (event.currentTarget.hasAttribute('data-dom-id')) {
  //     var domId = event.currentTarget.dataset.domId;
  //     // console.log(`a: ${ domId }`)
  //   } else {
  //     // var domId = `${ record_model }_${ record_id }_li`
  //     // console.log(`b: ${ domId }`)
  //   }

  //   fetch(
  //     path, {
  //       method: 'POST',
  //       dataType: 'script',
  //       credentials: 'include',
  //       headers: {
  //         'X-CSRF-Token': csrf
  //       }
  //     }
  //   );
  // }

  destroy(event) {
    const confirmationMessage = event.currentTarget.dataset.turboConfirm
    if (confirmationMessage && !window.confirm(confirmationMessage)) {
      event.preventDefault()
      return
    }

    var csrf = document.getElementsByName('csrf-token')[0].content;
    var record_model = event.currentTarget.dataset.recordModel;
    var record_id = event.currentTarget.dataset.recordId;

    // console.log(`record_model: ${record_model}, record_id: ${record_id}`)
    // console.log(`record_id: ${record_id}`)
    var path = event.currentTarget.dataset.destroyPath;
    // console.log(`path: ${path}`)

    if (event.currentTarget.hasAttribute('data-dom-id')) {
      var domId = event.currentTarget.dataset.domId;
      console.log(`a: ${ domId }`)
    } else {
      var domId = `${ record_model }_${ record_id }_li`
      console.log(`b: ${ domId }`)
    }

    if (domId.length > 0 && record_model != 'favorite_record') {
      document.getElementById(domId).classList.add('d-none');
      // console.log(`should have hid: ${ domId }`)
    }

    fetch(
      path, {
        method: 'DELETE',
        dataType: 'script',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': csrf
        }
      }
    );
  }

  hide(event) {
    var csrf         = document.getElementsByName('csrf-token')[0].content;
    var record_model = event.currentTarget.dataset.recordModel;
    var record_id    = event.currentTarget.dataset.recordId;
    var path         = event.currentTarget.dataset.updatePath;

    if (event.currentTarget.hasAttribute('data-dom-id')) {
      var domId = event.currentTarget.dataset.domId;
    } else {
      var domId = `${ record_model }_${ record_id }_li`
    }

    document.getElementById(domId).classList.add('d-none');

    fetch(
      path, {
        method: 'GET',
        dataType: 'script',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': csrf
        }
      }
    );
  }

  approve_reject(event) {
    var csrf         = document.getElementsByName('csrf-token')[0].content;
    var record_model = event.currentTarget.dataset.recordModel;
    var record_id    = event.currentTarget.dataset.recordId;
    var path         = event.currentTarget.dataset.updatePath;

    if (event.currentTarget.hasAttribute('data-dom-id')) {
      var domId = event.currentTarget.dataset.domId;
    } else {
      var domId = `${ record_model }_${ record_id }_li`
    }

    document.getElementById(domId).classList.add('d-none');

    fetch(
      path, {
        method: 'GET',
        dataType: 'script',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': csrf
        }
      }
    );
  }

  updateProjectCharge(event) {
    var csrf         = document.getElementsByName('csrf-token')[0].content;
    var formInputName = event.currentTarget.dataset.formInputName;
    if (!formInputName) { return; }
    var path         = `${ event.currentTarget.dataset.updatePath }?${ formInputName }=${ encodeURIComponent(event.currentTarget.value) }`;

    fetch(
      path, {
        method: 'GET',
        dataType: 'script',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': csrf
        }
      }
    );
  }

  createProjectCharge(event) {
    var csrf = document.getElementsByName('csrf-token')[0].content;
    var record_model = event.currentTarget.dataset.recordModel;
    var record_id = event.currentTarget.dataset.recordId;
    var val = event.currentTarget.value
    var path = `${ event.currentTarget.dataset.createPath }&amount=${ val }`;

    if (event.currentTarget.hasAttribute('data-dom-id')) {
      var domId = event.currentTarget.dataset.domId;
    } else {
      var domId = `${ record_model }_${ record_id }_li`
    }

    if (val != null) {
      fetch(
        path, {
          method: 'POST',
          dataType: 'script',
          credentials: 'include',
          headers: {
            'X-CSRF-Token': csrf
          }
        }
      );
    }
  }

  updateAttr(event) {
    var csrf         = document.getElementsByName('csrf-token')[0].content;
    var record_model = event.currentTarget.dataset.recordModel;
    var record_id    = event.currentTarget.dataset.recordId;
    var path         = `${ event.currentTarget.dataset.updatePath }?${ event.currentTarget.dataset.formInputName }=${ event.currentTarget.value }`;

    if (event.currentTarget.hasAttribute('data-dom-id')) {
      var domId = event.currentTarget.dataset.domId;
    } else {
      var domId = `${ record_model }_${ record_id }_li`
    }

    fetch(
      path, {
        method: 'GET',
        dataType: 'script',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': csrf
        }
      }
    );
  }

  swapOption(event) {
    var formIndex = event.currentTarget.dataset.formIndex;
    var selectorDomId = `selectDescription${ formIndex }`
    var textDomId = `textDescription${ formIndex }`

    document.getElementById(selectorDomId).classList.add('d-none');
    document.getElementById(textDomId).classList.remove('d-none');
  }

  revealBlankAircraftModel(event) {
    var selectorDomId = `aircraft_model_family_select`
    var textDomId = `blank_aircraft_model_family_select`

    document.getElementById(selectorDomId).classList.add('d-none');
    document.getElementById(textDomId).classList.remove('d-none');
  }

}
